import ServiceHardwareUI from"./ServiceHardwareUI";export default ServiceHardwareUI;